module.exports = global["jQuery"] = require("-!/home/runner/work/frontend/frontend/reverb-ui/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js
// module id = 7t+N
// module chunks = 25